import { memo, useEffect, useState } from "react";

function ProfileArea() {
  const [currentExp, setCurrentExp] = useState([]);
  const [importantExp, setImportantExp] = useState([]);

  useEffect(() => {
    const fetchList = async (section, setter) => {
      try {
        const res = await fetch("/api/website/getProfileExperienceList", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ section }),
        });
        const json = await res.json();
        if (json?.retStatus?.code === 10000) {
          setter(Array.isArray(json.data) ? json.data : []);
        } else {
          setter([]);
        }
      } catch (e) {
        setter([]);
      }
    };
    fetchList("current", setCurrentExp);
    fetchList("important", setImportantExp);
  }, []);

  return (
    <div className="bg-about-profile bg-no-repeat bg-cover bg-fixed top-[250px] py-[5%] sticky table:bg-none table:p-0 mobile:bg-none mobile:p-0">
      <div className="hidden bg-about-profile bg-no-repeat bg-cover aspect-[960/547] table:block mobile:block" />
      <div className="py-[75px] px-16 bg-white rounded-lg opacity-90 border-[3px] border-[#f2cd7c] ml-[35%] mr-[10%] table:mx-auto table:max-w-[800px] table:my-20 table:w-[90%] table:p-10 mobile:max-w-[500px] mobile:w-[90%] mobile:mx-auto mobile:my-8 mobile:p-4">
        <img className="profile-area-img mt-0" src="./asset/image/about/profile-now.png" alt="" />
        <div className="profile-exp-list">
          {currentExp.map((exp) => (
            <div className="profile-exp-row" key={exp.id}>
              <div>{exp.company}</div>
              <div>{exp.title}</div>
            </div>
          ))}
        </div>
        <img className="profile-area-img" src="./asset/image/about/profile-exp.png" alt="" />
        <div className="profile-exp-list">
          {importantExp.map((exp) => (
            <div className="profile-exp-row" key={exp.id}>
              <div>
                {exp.company}
                {exp.distributed && (
                  <>
                    <br /> {exp.distributed}
                  </>
                )}
              </div>
              <div>{exp.title}</div>
            </div>
          ))}
        </div>
        <img className="profile-area-img" src="./asset/image/about/profile-article.png" alt="" />
        <div>
          <img
            className="aspect-[285/400] w-[285px] mx-auto"
            src="./asset/image/about/profile-book.png"
            alt=""
          />
          <div className="profile-exp-list mt-20 table:mt-14 mobile:mt-10">
            <div className="profile-exp-row">
              <div className="profile-title">書名</div>
              <div>私人銀行與境外規劃</div>
            </div>
            <div className="profile-exp-row">
              <div className="profile-title">出版社</div>
              <div>安信國際資產管理顧問(股)公司</div>
            </div>
            <div className="profile-exp-row">
              <div className="profile-title">出版日期</div>
              <div>2008年3月</div>
            </div>
            <div className="profile-exp-row">
              <div className="profile-title">內容大綱</div>
              <div>
                私人銀行是資產保護、企業防火牆、
                <br />
                資產備份、 資產隱藏的最佳規劃管道，
                <br />
                能滿足頂級客戶需求與節稅規劃。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(ProfileArea);
